import { HelperCore } from '@/common/dependencies';
import { makeAutoObservable, runInAction } from 'mobx';

class Store {
  checkedList = [];

  constructor () {
    makeAutoObservable(this);

    if(!HelperCore.IS_PROD){
      window._genFileTypesStore = this;
    }
  }

  setCheckedList = (checkedList) => {
    this.checkedList = checkedList;
  }
  setChecked = (data) => {
    if(Array.isArray(data)){
      this.setCheckedList(data);
      return;
    }
    if(typeof data == "string"){
      const list = data.split("/");
      this.setCheckedList(list);
      return;
    }
  }
  hasChecked = (data) => {
    const list = data.split("/");
    return this.checkedList.some(item => list.includes(item));
  }
  reset = () => {
    this.setCheckedList([]);
  }
}

const genFileTypesStore = new Store();
export default genFileTypesStore;